import script from "./cnt-trial_version.vue?vue&type=script&lang=ts&setup=true"
export * from "./cnt-trial_version.vue?vue&type=script&lang=ts&setup=true"

import "./cnt-trial_version.vue?vue&type=style&index=0&id=192a5214&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-192a5214"]])

export default __exports__